import { render, staticRenderFns } from "./ContactRecap.vue?vue&type=template&id=0f8af2d0"
import script from "./ContactRecap.vue?vue&type=script&lang=ts"
export * from "./ContactRecap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports